[
  {
    "link": "001",
    "keyvisual": "https://www.minna-no-ginko.com/common/images/correspondence/correspondence_design.png",
    "status": "new",
    "catagory": "ユーザーガイド",
    "title": "アプリ内にユーザーガイドの導線を追加",
    "days": "2025.05.12"
  },
  {
    "link": "001",
    "keyvisual": "https://www.minna-no-ginko.com/common/images/correspondence/correspondence_design.png",
    "status": "new",
    "catagory": "ユーザーガイド",
    "title": "【レコード】<br>利用店名を表示できるように改善",
    "days": "2021.7.30​"
  },
  {
    "link": "001",
    "keyvisual": "https://www.minna-no-ginko.com/common/images/correspondence/correspondence_design.png",
    "status": "new",
    "catagory": "ユーザーガイド",
    "title": "アプリ内にユーザーガイドの導線を追加",
    "days": "2025.05.12"
  },
  {
    "link": "001",
    "keyvisual": "https://www.minna-no-ginko.com/common/images/correspondence/correspondence_design.png",
    "status": "new",
    "catagory": "ユーザーガイド",
    "title": "【レコード】<br>利用店名を表示できるように改善",
    "days": "2021.7.30​"
  },
  {
    "link": "001",
    "keyvisual": "https://www.minna-no-ginko.com/common/images/correspondence/correspondence_design.png",
    "status": "new",
    "catagory": "ユーザーガイド",
    "title": "アプリ内にユーザーガイドの導線を追加",
    "days": "2025.05.12"
  },
  {
    "link": "001",
    "keyvisual": "https://www.minna-no-ginko.com/common/images/correspondence/correspondence_design.png",
    "status": "new",
    "catagory": "ユーザーガイド",
    "title": "【レコード】<br>利用店名を表示できるように改善",
    "days": "2021.7.30​"
  },
  {
    "link": "001",
    "keyvisual": "https://www.minna-no-ginko.com/common/images/correspondence/correspondence_design.png",
    "status": "new",
    "catagory": "ユーザーガイド",
    "title": "アプリ内にユーザーガイドの導線を追加",
    "days": "2025.05.12"
  },
  {
    "link": "001",
    "keyvisual": "https://www.minna-no-ginko.com/common/images/correspondence/correspondence_design.png",
    "status": "new",
    "catagory": "ユーザーガイド",
    "title": "【レコード】<br>利用店名を表示できるように改善",
    "days": "2021.7.30​"
  },
  {
    "link": "001",
    "keyvisual": "https://www.minna-no-ginko.com/common/images/correspondence/correspondence_design.png",
    "status": "new",
    "catagory": "ユーザーガイド",
    "title": "【レコード】<br>利用店名を表示できるように改善",
    "days": "2021.7.30​"
  },
  {
    "link": "001",
    "keyvisual": "https://www.minna-no-ginko.com/common/images/correspondence/correspondence_design.png",
    "status": "new",
    "catagory": "ユーザーガイド",
    "title": "アプリ内にユーザーガイドの導線を追加",
    "days": "2025.05.12"
  },
  {
    "link": "001",
    "keyvisual": "https://www.minna-no-ginko.com/common/images/correspondence/correspondence_design.png",
    "status": "new",
    "catagory": "ユーザーガイド",
    "title": "【レコード】<br>利用店名を表示できるように改善",
    "days": "2021.7.30​"
  },
  {
    "link": "001",
    "keyvisual": "https://www.minna-no-ginko.com/common/images/correspondence/correspondence_design.png",
    "status": "new",
    "catagory": "ユーザーガイド",
    "title": "アプリ内にユーザーガイドの導線を追加",
    "days": "2025.05.12"
  },
  {
    "link": "001",
    "keyvisual": "https://www.minna-no-ginko.com/common/images/correspondence/correspondence_design.png",
    "status": "new",
    "catagory": "ユーザーガイド",
    "title": "【レコード】<br>利用店名を表示できるように改善",
    "days": "2021.7.30​"
  },
  {
    "link": "001",
    "keyvisual": "https://www.minna-no-ginko.com/common/images/correspondence/correspondence_design.png",
    "status": "new",
    "catagory": "ユーザーガイド",
    "title": "アプリ内にユーザーガイドの導線を追加",
    "days": "2025.05.12"
  },
  {
    "link": "001",
    "keyvisual": "https://www.minna-no-ginko.com/common/images/correspondence/correspondence_design.png",
    "status": "new",
    "catagory": "ユーザーガイド",
    "title": "【レコード】<br>利用店名を表示できるように改善",
    "days": "2021.7.30​"
  }
]